import { uniqueId } from "lodash";
import { useEffect, useState } from "react";
import { useLogger } from "../providers/LogProvider";

export interface UseWindowPostMessageProps {
	allowedMessageOrigins: string[];
	onMessage: (message: PostMessageEvent) => void;
}

export interface PostMessageEvent {
	windowID: string;
	payload: any;
}

export interface SendMessageProps {
	message: object;
	targetWindow?: Window;
	targetOrigin?: string;
}
const windowID = uniqueId();
export const useWindowPostMessage = ({
	allowedMessageOrigins: allowedMessageOriginsInitial,
	onMessage
}: UseWindowPostMessageProps) => {
	const [allowedMessageOrigins, setAllowedMessageOrigins] = useState(allowedMessageOriginsInitial);
	const logger = useLogger("hooks.useWindowPostMessage");
	useEffect(() => {
		const handleMessage = (event: MessageEvent<string>) => {
			// Check if the message is from the expected origin
			if (allowedMessageOrigins.includes(event.origin) || allowedMessageOrigins.includes("*")) {
				let parsed: PostMessageEvent;
				try {
					parsed = typeof event.data === "string" ? JSON.parse(event.data) : event.data;
					if (!parsed.windowID || parsed.windowID !== windowID) {
						return;
					}
				} catch (e) {
					logger.error("handleMessage", "useWindowPostMessage: handleMessage Error", e);
				}
				onMessage(parsed);
			}
		};

		// Add event listener for messages
		window.addEventListener("message", handleMessage);

		// Clean up the event listener on component unmount
		return () => {
			window.removeEventListener("message", handleMessage);
		};
	}, [allowedMessageOrigins]);

	const sendMessage = ({ message, targetOrigin, targetWindow }: SendMessageProps) => {
		// Check if targetWindow is provided, otherwise use parent window
		const target = targetWindow || window.parent;
		const event: PostMessageEvent = { windowID, payload: message };
		target.postMessage(JSON.stringify(event), targetOrigin || "*");
	};

	return { sendMessage };
};
export default useWindowPostMessage;
